import { render, staticRenderFns } from "./indexWorkEditServicer.vue?vue&type=template&id=3756ca49&"
import script from "./indexWorkEditServicer.vue?vue&type=script&lang=ts&"
export * from "./indexWorkEditServicer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports